export const fetchProductStressMarketingsData = () => {
	// Legacy feature, todo: remove all reference in code
};
